import script from "./ButtonLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonLoading.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonLoading.vue?vue&type=style&index=0&id=da6d6f32&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da6d6f32"]])

export default __exports__